module.exports = __webpack_public_path__ + "img/uk-pro-desc.2bdf7c05.png";